import React from 'react';

const StatTile = ({ label, value, dark = true }) => {
  const isText = typeof value === 'string';
  return (
    <div
      className={`h-[85px] flex justify-between flex-col overflow-hidden border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder ${
        dark ? 'bg-blue-900 text-white' : 'bg-shoorah-ggg'
      }`}
    >
      <div className={`text-[14px] font-medium ${dark ? 'text-shoorah-darkBg' : 'text-gray-400 dark:text-shoorah-darkBg'}`}>
        {label}
      </div>
      <div
        title={isText ? value : undefined}
        className={`font-medium overflow-hidden truncate ${isText ? 'text-sm lg:text-base' : 'text-lg lg:text-2xl'} ${dark ? 'text-shoorah-darkBg' : 'text-black dark:text-shoorah-darkBg'}`}
      >
        {value ?? 0}
      </div>
    </div>
  );
};

const SectionCard = ({ title, children }) => (
  <div className="border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl md:p-6 p-4 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
    <h3 className="text-base font-medium text-gray-700 dark:text-shoorah-darkBg mb-3">{title}</h3>
    <div className="grid grid-cols-2 gap-3">{children}</div>
  </div>
);

const NutritionStats = ({ stats }) => {
  if (!stats) return null;

  const { recipes, mealPlans } = stats;

  return (
    <div className="mb-6">
      <div className="text-lg md:text-xl font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-4">
        Nutrition Statistics
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <SectionCard title="Recipes">
          <StatTile label="Total Recipes" value={recipes?.total} />
          <StatTile label="Active Recipes" value={recipes?.active} />
        </SectionCard>

        <SectionCard title="Meal Plans">
          <StatTile label="Total Plans" value={mealPlans?.total} />
          <StatTile label="Users With Plan" value={mealPlans?.totalUsersWithMealPlan} />
          <StatTile label="Completed" value={mealPlans?.completed} />
          <StatTile label="Pending" value={mealPlans?.pending} dark={false} />
          <StatTile
            label="Most Used Recipe"
            value={mealPlans?.mostUsedRecipe?.title ?? 'N/A'}
            dark={false}
          />
        </SectionCard>
      </div>
    </div>
  );
};

export default NutritionStats;
